module.exports = __webpack_public_path__ + "static/media/ethereum-logo.png.47267958.bak";